import { Box, SxProps, Theme, Typography } from '@mui/material';
import { IBlogAuthorProps } from '../BlogAuthorDetails';
import { BLOG_AUTHOR_LABELS } from '../BlogDetailsPage.constants';
import { blogAuthorImageCtrStyles, blogAuthorImageStyles } from '../BlogDetailsPage.styles';
import { blogAuthorGridImageStyles, blogAuthorListGridStyles, blogAuthorStyles } from './BlogDetailsHero.styles';
import FocalPointImage from '@shared-components/components/FocalPointImage';
import { Maybe } from '@shared-components/types';
interface BlogDetailsHeroAuthorListProps {
  author?: Maybe<IBlogAuthorProps>;
  reviewer?: Maybe<IBlogAuthorProps>;
  textColor?: Maybe<string>;
  theme: Theme;
}
const BlogDetailsHeroAuthorListItem = ({
  author,
  textColor,
  authorLabel = 'Authored By',
  sx
}: {
  author: IBlogAuthorProps;
  textColor: BlogDetailsHeroAuthorListProps['textColor'];
  authorLabel?: string;
  sx?: SxProps;
}) => {
  return <Box sx={{
    ...sx,
    display: 'flex',
    flexFlow: 'row no-wrap',
    gap: '.25rem'
  }} data-sentry-element="Box" data-sentry-component="BlogDetailsHeroAuthorListItem" data-sentry-source-file="BlogDetailsHeroAuthorList.tsx">
			<Box data-sentry-element="Box" data-sentry-source-file="BlogDetailsHeroAuthorList.tsx">
				<Typography variant="bodyMediumBold" color={textColor ?? ''} component="p" data-sentry-element="Typography" data-sentry-source-file="BlogDetailsHeroAuthorList.tsx">
					{authorLabel}
				</Typography>
				<Typography variant="bodyMediumBook" color={textColor ?? ''} component="p" data-sentry-element="Typography" data-sentry-source-file="BlogDetailsHeroAuthorList.tsx">
					{author.name && <span data-testid="blog_details_hero_author_name">{author.name}</span>}
					{author.title && <span data-testid="blog_details_hero_author_title"> {author.title}</span>}
				</Typography>
			</Box>
		</Box>;
};
export default function BlogDetailsHeroAuthorList({
  author,
  reviewer,
  textColor
}: Readonly<BlogDetailsHeroAuthorListProps>) {
  if (!author && !reviewer) return <></>;
  const reviewerLabel = BLOG_AUTHOR_LABELS.MEDICALLY_REVIEWED_BY;
  const authorLabel = reviewer ? BLOG_AUTHOR_LABELS.AUTHORED_BY : `Authored & ${reviewerLabel}`;
  const hasAuthorImage = !!author?.image;
  return <Box sx={blogAuthorListGridStyles(hasAuthorImage)} data-sentry-element="Box" data-sentry-component="BlogDetailsHeroAuthorList" data-sentry-source-file="BlogDetailsHeroAuthorList.tsx">
			{hasAuthorImage && <Box sx={{
      ...blogAuthorImageCtrStyles,
      ...blogAuthorGridImageStyles
    }}>
					<FocalPointImage brandFolderImage={author?.image?.image} focalPoint={author?.image?.focalPoint} imageSx={blogAuthorImageStyles} />
				</Box>}
			{author && <BlogDetailsHeroAuthorListItem author={author} textColor={textColor} authorLabel={authorLabel} sx={blogAuthorStyles} />}
			{reviewer && <BlogDetailsHeroAuthorListItem author={reviewer} textColor={textColor} authorLabel={reviewerLabel} />}
		</Box>;
}